import Vue from 'vue'
import App from './App'
import { router } from './router'
import VueSweetalert2 from 'vue-sweetalert2';


import './static/css/global.css';
import { initFixedHeader } from './static/js/global.js'

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
import VueApexCharts from 'vue-apexcharts'
import { helper } from './helper'

import store from './store/index.js'
Vue.prototype.$store = store;


// import { Toast, Loading, Locale, Uploader, Popup, Dialog, Notify, Overlay, Switch, Icon } from 'vant';
// Vue.use(Toast);
// // import 'vant/lib/toast/style';
// Vue.use(Loading);
// import 'vant/lib/loading/style';
// Vue.use(Uploader);
// // import 'vant/lib/uploader/style';
// Vue.use(Popup);
// // import 'vant/lib/popup/style';
// Vue.use(Dialog);
// // import 'vant/lib/dialog/style';
// Vue.use(Notify);
// // import 'vant/lib/notify/style';
// Vue.use(Overlay);
// import 'vant/lib/overlay/style';
// Vue.use(Switch);
// // import 'vant/lib/switch/style';
// Vue.use(Icon);
// // import 'vant/lib/icon/style';
// import trTR from 'vant/lib/locale/lang/tr-TR';
// Locale.use('tr-Tr', trTR);





Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false

//alert("drg")
/* eslint-disable no-new */
// let options = {
//   sound: true, // default is false
//   soundSrc: '/static/sound.wav', // default is blank
//   sensitivity: 300, // default is 100
//   requiredAttr: true, // default is false
//   controlSequenceKeys: ['NumLock', 'Clear'], // default is null
//   callbackAfterTimeout: true // default is false
// }

//Vue.use(VueBarcodeScanner, options);

//function createApp() {
new Vue({
  el: '#app',
  router,
  //store,
  render: h => h(App),
  mounted() {
    // Vue DOM’u bastıktan sonra çalışır
    initFixedHeader()
  }
})
// }
// if (store.restored && typeof store.restored.then === 'function') {
//   store.restored.then(() => {
//     createApp()
//   })
// } else {
//   createApp()
// }


// WEBPACK FOOTER //
// ./src/main.js